import {Col, Row} from 'antd';
import React from 'react';

import BoxContent from '../../../../../../components/BoxContent/BoxContent';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import AllFacilityDisplay from '../../../../components/AllFacilityDisplay';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';
import AllSuppliers from '../../../../supplyChain/utils/AllSuppliers';

const FinancialElecWater: React.FC<{
  data: any[];
  type?: 'electricity' | 'water';
}> = ({data, type = 'electricity'}) => {
  const isElect = type === 'electricity';

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={24}>
          <TotalChartList
            chartType="line"
            showTotal={false}
            keyArray={[
              isElect ? 'electricity cost trends' : 'water cost trends'
            ]}
            data={data}
            dataInMainData={true}
            showChartList={false}
            isCost={true}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
        <Col span={6}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="cost per employee"
                isCost={true}
              />
            </Col>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="cost per unit of production/revenue"
                isCost={true}
              />
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          {isElect ? (
            <AllFacilityDisplay
              data={data}
              keyArray={['electricity cost']}
              type="electricCost"
              showFilter={false}
              isSingle={true}
              customTitle="TOTAL COST"
              customCalKey="value"
              isCost={true}
            />
          ) : (
            <AllSuppliers
              data={data}
              keyArray={['water cost by location']}
              type="waterCost"
              customTitle="TOTAL FACILITY"
            />
          )}
        </Col>
        <Col span={6}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            {isElect ? (
              <>
                <Col span={24} style={{height: convertPxToRem(317)}}>
                  <ValueRepresentationBox
                    data={data}
                    mainKey="total electricity cost"
                    isCost={true}
                  />
                </Col>
                <Col span={24} style={{height: convertPxToRem(317)}}>
                  <BoxContent />
                </Col>
              </>
            ) : (
              <Col span={24}>
                <BoxContent />
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default FinancialElecWater;
